import React from 'react';
import './PlanningPRS.css';
import PlanningHero from '../../components/PlanningHero/PlanningHero.jsx'; // Optional hero banner

const PlanningPRS = () => {
  return (
    <div className="planning-prs">
      <PlanningHero />

      <section className="prs-intro">
        <div className="prs-intro-content">
          <div className="prs-text">
            <h2>Strategic Development and Data-Driven Governance</h2>
            <p>
              The Department of Planning, Research & Statistics (PRS) is the think tank of Igbo-Eze North Local Government. 
              It spearheads policy planning, data management, monitoring and evaluation, and coordination of development partnerships.
            </p>
          </div>
        </div>
      </section>

      <section className="prs-responsibilities">
        <h2>Core Responsibilities</h2>
        <ul>
          <li>📊 Leading the preparation and implementation of the Medium-Term Development Plan (MTDP)</li>
          <li>📈 Coordinating data collection, analysis, and monitoring & evaluation (M&E)</li>
          <li>🤝 Managing donor relations and development partner engagements</li>
          <li>📝 Drafting proposals, progress reports, and planning documents</li>
          <li>🌐 Operating the Council’s digital platforms and statistical systems</li>
        </ul>
      </section>

      <section className="prs-impact">
        <h2>Why PRS Matters</h2>
        <p>
          Good planning ensures that resources are allocated where they’re most needed. 
          The PRS Department drives transparency and effectiveness by using evidence-based decision-making and strategic foresight to support sustainable local development.
        </p>
      </section>
    </div>
  );
};

export default PlanningPRS;